<section class="secondary">
  <section
    class="intro text-white ptb-25"
    style="background-image:url(' {{
      slogan?.homeHeaderImage2 || slogan?.homeHeaderImage
    }} ');"
  >
    <div class="container">
      <div
        class="main-title size-59 weight-700 w-100 max-600 height-345 mrb-20 mrt-10 mrb-md-15 mrt-md-35"
        data-aos="fade-up"
        data-aos-duration="1000"
      >
        {{ slogan?.homeHeaderTitle || slogan?.homeHeaderTitleAr }}
      </div>
      <div data-aos="fade-up" data-aos-duration="1500">
        <a
          routerLink="session"
          class="book-now-btn border pse-20 border-radius-10 w-100 max-300 text-center hover-btn weight-700 ptb-5 size-12"
          >{{ "MainOffers" | translate }}</a
        >
      </div>
    </div>
  </section>
</section>
<section class="service text-primary pt-35 pb-60 bg-gray3">
  <div class="container">
    <div
      class="section-title mrb-8 text-center weight-700 size-35 text-truncate"
      data-aos="fade-up"
      data-aos-duration="1000"
    >
      {{ slogan?.homeServicesTitle || slogan?.homeServicesTitleAr }}
    </div>
    <div
      class="pargraph mrb-35 text-center weight-600 size-10"
      data-aos="fade-up"
      data-aos-duration="1500"
      [innerHTML]="
        slogan?.homeServicesDescription || slogan?.homeServicesDescriptionAr
      "
    ></div>
    <div class="row">
      <div
        class="col-12 col-md-6 col-lg-3 mb-5"
        *ngFor="let service of services"
        data-aos="fade-up"
        data-aos-duration="1500"
      >
        <a [routerLink]="['/service', service.serviceId]">
          <app-service
            [image]="service?.thumbnail"
            [name]="service?.name || service?.nameAr"
          ></app-service>
        </a>
      </div>
    </div>
  </div>
</section>
<section class="about-us text-primary pb-50 pt-65">
  <div class="container">
    <div class="row">
      <div
        class="col-12 col-md-5 text-md-end"
        data-aos="fade-up"
        data-aos-duration="1000"
      >
        <img
          class="w-100 max-430 height-345"
          [src]="about?.summaryImage"
          alt="about img"
        />
      </div>
      <div
        class="col-12 col-md-7 text-start"
        data-aos="fade-up"
        data-aos-duration="1500"
      >
        <div class="mrs-md-30">
          <div class="section-title mrb-20 weight-700 size-35 text-truncate">
            {{ about?.summaryTitle || about?.summaryTitleAr }}
          </div>
          <div
            class="paragraph w-100 max-800 size-10"
            [innerHTML]="
              about?.summaryDescription || about?.summaryDescriptionAr
            "
          ></div>
          <a
            class="more-btn hover-more-btn d-flex align-items-center mrt-20"
            routerLink="about-us"
          >
            <div class="size-3 weight-700 mre-5">
              {{ "knowMore" | translate }}
            </div>
            <svg-icon
              class="arrow"
              src="../../../../assets/images/arrow.svg"
            ></svg-icon>
            <div class="arrow"></div>
          </a>
        </div>
      </div>
    </div>
  </div>
  <img
    class="w-100 mrt-40"
    src="../../../assets/images/pattern.svg"
    alt="line"
  />
</section>
<!-- <section class="sessions text-primary ptb-25 bg-gray3">
  <div class="container">
    <div
      class="section-title mrb-35 text-center weight-700 size-35 text-truncate"
    >
      {{ slogan?.homeOffersTitleAr || slogan?.homeOffersTitle }}
    </div>
    <div class="row">
      <div class="col-12 col-md-6 col-lg-3" *ngFor="let offer of offers">
        <a [routerLink]="['/session/book', offer.sessionId]">
          <app-session-item
            [image]="offer.imageUrl"
            [name]="offer.name || offer.nameAr"
            [salePrice]="offer.salePrice"
            [price]="offer.price"
            [sessionId]="offer?.sessionId"
          ></app-session-item>
        </a>
      </div>
    </div>
    <a
      class="more-btn hover-more-btn d-flex justify-content-end align-items-center mrt-20"
      routerLink="session"
    >
      <div class="size-3 weight-700 mre-5">{{ "knowMore" | translate }}</div>
      <svg-icon
        class="arrow"
        src="../../../../assets/images/arrow.svg"
      ></svg-icon>
      <div class="arrow"></div>
    </a>
  </div>
</section> -->
<section class="instructions text-primary ptb-25 bg-gray3">
  <div class="container">
    <div
      class="section-title mrb-35 text-center weight-700 size-35 text-truncate"
      data-aos="fade-up"
      data-aos-duration="1000"
    >
      <!-- {{
        slogan?.homeHealthEducationTitle || slogan?.homeHealthEducationTitleAr
      }} -->
      {{ "header.blog" | translate }}
    </div>
    <div class="row">
      <div
        class="col-12 col-md-6 col-lg-4"
        *ngFor="let healthEducation of healthEducations"
        data-aos="fade-up"
        data-aos-duration="1500"
      >
        <a
          [routerLink]="[
            '/health-education',
            healthEducation?.healthEducationId
          ]"
        >
          <health-education
            [title]="healthEducation?.title || healthEducation?.titleAr"
            [image]="healthEducation?.foregroundImage"
            [healthEducationId]="healthEducation?.healthEducationId"
          >
          </health-education>
        </a>
      </div>
    </div>
    <a
      class="more-btn hover-more-btn d-flex justify-content-center align-items-center mrt-20"
      routerLink="health-education"
    >
      <div class="size-3 weight-700 mre-5">{{ "knowMore" | translate }}</div>
      <svg-icon
        class="arrow"
        src="../../../../assets/images/arrow.svg"
      ></svg-icon>
    </a>
  </div>
</section>
<!-- <section class="testimonials text-primary ptb-25 bg-gray3">
    <div class="container">
        <div class="section-title mrb-35 text-center weight-700 size-25 text-truncate">{{ 'reviews' | translate }}
        </div>
        <owl-carousel-o [options]="customOptions">
            <ng-template carouselSlide *ngFor = "let testimonial of testimonials">
                <app-review [image]="testimonial?.imageUrl" [name]="testimonial?.name" [content]="testimonial?.content"></app-review>
            </ng-template>
        </owl-carousel-o>
    </div>
</section> -->
<!-- <section class="latest-news text-primary ptb-25 bg-gray3">
  <div class="container">
    <div
      class="section-title mrb-35 text-center weight-700 size-35"
      data-aos="fade-up"
      data-aos-duration="1000"
    >
      {{ slogan?.homeNewsTitle || slogan?.homeNewsTitleAr }}
    </div>
    <div class="row">
      <div
        class="col-12 col-md-4"
        *ngFor="let new of news"
        data-aos="fade-up"
        data-aos-duration="1500"
      >
        <a [routerLink]="['/news', new.newsId]">
          <app-new-item
            [image]="new?.foregroundImage"
            [title]="new?.title || new?.titleAr"
            [text]="new?.excerpt || new?.excerptAr"
            [hoverTitle]="new.slug"
            [hoverText]="new?.body || new?.bodyAr"
          >
          </app-new-item>
        </a>
      </div>
    </div>
  </div>
</section> -->
<section class="book-now secondary ptb-25">
  <div class="container">
    <div class="row align-items-center">
      <div
        class="col-md-6 col-12 text-end"
        data-aos="fade-up"
        data-aos-duration="1000"
      >
        <img
          class="w-100 max-500"
          [src]="slogan?.bookImage"
          alt="book now img"
        />
      </div>
      <div
        class="col-md-6 col-12 text-white"
        data-aos="fade-up"
        data-aos-duration="1500"
      >
        <div
          class="big-text size-15 size-lg-30 w-100 max-400 weight-700 mrb-30 mrt-5 mrt-xl-0"
        >
          {{ slogan?.bookTitle || slogan?.bookTitleAr }}
        </div>
        <a
          class="book-now-btn cursor-pointer bg-white text-primary ptb-4 pse-45 mrt-10 border-radius-10 size-15 weight-600"
          [routerLink]="['/session']"
          >{{ "bookNow" | translate }}</a
        >
      </div>
    </div>
  </div>
</section>
